<ng-container *ngIf="isLoadingLessorAreaMaker === false">

  <div class="contents">
    <div class="form_input">
      <h2 class="title">Survey Area</h2>

      <form [formGroup]="surveyForm">
        <div class="input">
          <label for="">Description</label>
          <input type="text" formControlName="LessorAreaMakerDesc" class="default_input reference-form" />
        </div>
        <div class="input">
          <label for="">Lat Deg</label>
          <input type="number" formControlName="PobLatitudeDegree" class="default_input reference-form" />
        </div>
        <div class="input">
          <label for="">Lat Min</label>
          <input type="number" formControlName="PobLatitudeMin" class="default_input reference-form" />
        </div>
        <div class="input">
          <label for="">Lat Sec</label>
          <input type="number" formControlName="PobLatitudeSec" class="default_input reference-form" />

        </div>
        <div class="input">
          <label for="">Long Deg</label>
          <input type="number" formControlName="PobLongitudeDegree" class="default_input reference-form" />
        </div>
        <div class="input">
          <label for="">Long Min</label>
          <input type="number" formControlName="PobLongitudeMin" class="default_input reference-form" />
        </div>

        <div class="input">
          <label for="">Long Sec</label>
          <input type="number" formControlName="PobLongitudeSec" class="default_input reference-form" />
        </div>

        <div class="input">
          <label for="">Northing</label>
          <input type="number" formControlName="LessorAreaMakerNorthing" class="default_input reference-form" />
        </div>

        <div class="input">
          <label for="">Easting</label>
          <input type="number" formControlName="LessorAreaMakerEasting" class="default_input reference-form" />

        </div>
        <div class="input">
          <label for="">Remark</label>
          <input type="text" formControlName="LessorAreaMakerRemarks" class="default_input reference-form" />
        </div>
      </form>
      <div class="btn_holder">
        <button class="default_primary-button" type="submit"  (click)="addNew(surveyForm.value)">
          <ng-container *ngIf="selectedIndex === null">
            Add  &rarr;
          </ng-container>
          <ng-container *ngIf="selectedIndex !== null">
            Update  &rarr;
          </ng-container>
        </button>

        <div class="refresh">
          <button mat-button (click)="onReset()">
             <i class="material-icons">
              settings_backup_restore
              </i>Reset</button>
          </div>
      </div>
    </div>


    <cradua-survey-area-table
    [lessorAreaMakers]="lessorAreaMakers"
    [selectedLessorInfo]="selectedLessorInfo"
    (emitEdit)="onEdit($event)"
    >
    </cradua-survey-area-table>
  </div>

  <div class="acquisition_submit">
    <button class="default_primary-button" (click)="onSubmit()" type="submit">
      Save
    </button>
    <button class="default_secondary-btn ml-2" (click)="onBack()"> <i class="ti-arrow-left"></i> Back</button>

  </div>

</ng-container>

<cradua-list-spinner
*ngIf="isLoadingLessorAreaMaker === true"
>
</cradua-list-spinner>



